export function getProgressValue({ totalValue, value }) {
    if (totalValue === 0) {
        return 0;
    }

    const progress = value / totalValue;

    return Math.min(progress, 1.0) * 100;
}